import { c as _c } from "react/compiler-runtime";
import type { RuleCategoryKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';

/** `key` names which document node's signals the category covers, so a playbook collecting
 * several documents doesn't label them all identically. */
export const useTranslateCategory = (category, key) => {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "rules.addDefaultRules.category"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp7);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp8);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = {
      kyc: t1,
      id_document: t2,
      duplicate_fraud: t3,
      behavior_fraud: t4,
      person_aml: t5,
      kyb: t6,
      phone: t7,
      synthetic_fraud: t8
    };
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const categoryTranslations = t9;
  const label = categoryTranslations[category];
  return key ? `${label} (${key})` : label;
};
function _temp($) {
  return $.kyc;
}
function _temp2($_0) {
  return $_0.id_document;
}
function _temp3($_1) {
  return $_1.duplicate_fraud;
}
function _temp4($_2) {
  return $_2.behavior_fraud;
}
function _temp5($_3) {
  return $_3.person_aml;
}
function _temp6($_4) {
  return $_4.kyb;
}
function _temp7($_5) {
  return $_5.phone;
}
function _temp8($_6) {
  return $_6.synthetic_fraud;
}